module.exports = __webpack_public_path__ + "img/vegetable-kohlrabi-190x100.e8aff5ca.jpg";